import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import 'rc-checkbox/assets/index.css';
import { injectIntl } from 'react-intl';
import TextComponent from './TextComponent';
import { objectValues } from '../Utils';

class TextEditor extends Component {
    state = {
        showText: false
    };

    renderTextComponents = () =>
        objectValues(this.props.texts).map(textObj => {
            const { id } = textObj;
            return (
                <TextComponent
                    removeText={this.props.removeText.bind(this, id)}
                    {...textObj}
                    key={id}
                    onChangeText={this.props.onChangeText.bind(this, id)}
                    selectFont={this.props.selectFont.bind(this, id)}
                    selectColor={this.props.selectColor.bind(this, id)}
                    selectSize={this.props.selectSize.bind(this, id)}
                    selectRotation={this.props.selectRotation.bind(this, id)}
                    selectFontWeight={this.props.selectFontWeight.bind(
                        this,
                        id
                    )}
                    selectTextAlignment={this.props.selectTextAlignment.bind(
                        this,
                        id
                    )}
                />
            );
        });

    render() {
        const { messages } = this.props.intl;
        return (
            <div className="react-avatar-right-column">
                <div className="react-avatar-right-column-header">
                    <p className="react-avatar-right-column-header-text">
                        {messages.text}
                    </p>
                    <Button onClick={this.props.addText} bsStyle="primary">
                        {messages.addText}
                    </Button>
                </div>
                {this.renderTextComponents()}
            </div>
        );
    }
}

export default injectIntl(TextEditor);



// WEBPACK FOOTER //
// ./src/Components/TextEditor.js